import { render, staticRenderFns } from "./CompanyPartnerDialog.vue?vue&type=template&id=2bcdfeb2&scoped=true"
import script from "./CompanyPartnerDialog.vue?vue&type=script&lang=js"
export * from "./CompanyPartnerDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyPartnerDialog.vue?vue&type=style&index=0&id=2bcdfeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdfeb2",
  null
  
)

export default component.exports